import styles from "../styles/main.module.css";
import "react-toastify/dist/ReactToastify.css";

import {toast, ToastContainer} from 'react-toastify';
import {useEffect, useState} from "react";
import StandardRadioGroup from "../components/basic/StandardRadioGroup";
import {
    KEY_IMAGE_PATH,
    MAIN_CREDENTIALS_CHANGE_TYPE,
    REGISTER_FORM_RADIO_DATA,
    REGISTER_KEY_DOWNLOAD_TYPES,
} from "../utils/constants";
import StandardFileInput from "../components/basic/StandardFileInput";
import StandardPasswordInput from "../components/basic/StandardPasswordInput";
import StandardButton from "../components/basic/StandardButton";
import {generateOrGetDeviceId} from "../cookie";
import {
    addTextOnImage,
    createFile,
    createImage, createZip,
    downloadFile,
    prepareUsernameForKeyImageText,
    userIsLoggedIn
} from "../utils/utils";
import {useLocation} from "react-router-dom";
import StateManager from "../redux/StateManager";
import {changePrivateKeyPassphrase, generatePGPKeys} from "../business/encryption/pgp";
import {generateSha512Hash} from "../business/hashing";
import {adjustLoginForUser, fetchExistingReEncryptionProgress} from "../server-calls";
import {useNavigation} from "../hooks/navigation";
import * as _ from "lodash"
import {initializeSocket} from "../socket";
import "react-toastify/dist/ReactToastify.css";

export default function PasswordChange() {


    const TOAST_CONTAINER_ID= "passwordChange-toast-container"

    const location = useLocation()
    const {reloadPage, redirect} = useNavigation()
    useEffect(() => {

        if (!_.isEmpty(location.state) && !_.isEmpty(location.state.fromLogin) && location.state.resp.isReEncryptionOnGoing) {
            setToken(location.state.resp.token)
            setEmail(location.state.email)
            continueExistingProgress()
        } else {
            userIsLoggedIn().then((isLoggedIn) => {
                if (!isLoggedIn) {
                    redirect("/login")
                }
            }).then(() => {
                return fetchExistingReEncryptionProgress(StateManager.getToken())
            }).then((progress) => {

                if (!_.isEmpty(progress) && progress.status === "inProgress") {
                    setReEncryptionOnGoing(true)
                    setTotalMessages(progress.totalMessages)
                    setDoneMessages(progress.totalChanged)
                    setCurrentMbox(progress.currentMbox)
                }
            })
        }
    }, []);

    async function continueExistingProgress() {
        let progress = await fetchExistingReEncryptionProgress(token)

        if (!_.isEmpty(progress) && progress.status === "inProgress") {
            setReEncryptionOnGoing(true)
            setTotalMessages(progress.totalMessages)
            setDoneMessages(progress.totalChanged)
            setCurrentMbox(progress.currentMbox)
        }

        handleSocket()

    }

    const handleSocket = () => {
        let socket = initializeSocket(email, token, generateOrGetDeviceId)
        socket.on("message", (message) => {
            message = JSON.parse(message)
            console.log(message)
            if (message.eventType === "messageReEncrypted") {
                if (!_.isEmpty(message.finished)) {
                    toast.success("re-encryption finished", {containerId: TOAST_CONTAINER_ID})
                    setTimeout(() => {
                        redirect("/login")
                    }, 3000)
                } else {
                    setTotalMessages(message.totalMessages)
                    setDoneMessages(message.totalChanged)
                }
            }
        })
    }

    const [formOptions] = useState([
        REGISTER_FORM_RADIO_DATA.generateKeys,
        REGISTER_FORM_RADIO_DATA.uploadPublicKey,
        REGISTER_FORM_RADIO_DATA.emailPass
    ])
    let [formOption, setFormOption] = useState(REGISTER_FORM_RADIO_DATA.emailPass.value);
    let [mainChangeType, setMainChangeType] = useState(MAIN_CREDENTIALS_CHANGE_TYPE.changePassphrase.value);
    let [mainChangeTypes] = useState([
        MAIN_CREDENTIALS_CHANGE_TYPE.changePassphrase,
        MAIN_CREDENTIALS_CHANGE_TYPE.changeKeyPair
    ])
    let [keyDownloadOptions] = useState([
        REGISTER_KEY_DOWNLOAD_TYPES.image,
        REGISTER_KEY_DOWNLOAD_TYPES.text
    ])

    let [newLoginTypes] = useState([
        {
            text: "Email Pass",
            value: "emailPass",
        },
        {
            text: "Upload key",
            value: "uploadKey"
        }
    ])

    let [reEncryptionOnGoing, setReEncryptionOnGoing] = useState(false)
    let [newLoginType, setNewLoginType] = useState(newLoginTypes[1].value)
    let [keyDownloadOption, setKeyDownloadOption] = useState(REGISTER_KEY_DOWNLOAD_TYPES.image.value)
    let [newPassphrase, setNewPassphrase] = useState("")
    let [deviceId] = useState(generateOrGetDeviceId)
    let [isReEncryptionInProgress, setIsReEncryptionInProgress] = useState(false)
    let [totalMessages, setTotalMessages] = useState(0)
    let [doneMessages, setDoneMessages] = useState(0)
    let [currentMbox, setCurrentMbox] = useState("")
    let [token, setToken] = useState("")
    let [email, setEmail] = useState("")
    let [progressStarted, setProgressStarted] = useState(false)


    function handlePublicKeyUpload() {

    }

    function handleSubmit() {
        switch (mainChangeType) {
            case MAIN_CREDENTIALS_CHANGE_TYPE.changePassphrase.value:
                return changePassphrase();
            case MAIN_CREDENTIALS_CHANGE_TYPE.changeKeyPair.value:
                return generateNewKeyPairAndReEncrypt()
            default:
                return changePassphrase()
        }
    }

    async function changePassphrase() {
        toast.loading("changing passphrase of your key.", {containerId: TOAST_CONTAINER_ID})
        try {
            let newPrivateKey = await changePrivateKeyPassphrase(StateManager.getPrivateKey(), StateManager.getPassphrase(), newPassphrase)

            if (newLoginType === "emailPass") {
                let accessToken = generateSha512Hash(newPassphrase)
                await adjustLoginForUser({
                    mainChangeType,
                    newLoginType,
                    privateKey: newPrivateKey,
                    accessToken
                }, StateManager.getToken())
            } else {
                await downloadKey(StateManager.getUserEmail(), newPrivateKey, keyDownloadOption)
            }

            StateManager.cleanState()
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.success("Your passphrase has been changed. Please login again.")
            setTimeout(() => {
                reloadPage()
            }, 5000)
        } catch (e) {
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.error("error changing passphrase")
            console.error(e)
        }

    }

    async function downloadKey(userEmail, newPrivateKey, keyDownloadOption) {
        if (keyDownloadOption === REGISTER_KEY_DOWNLOAD_TYPES.text.value) {
            await downloadPrivateKeyAsText(StateManager.getUserEmail(), newPrivateKey)
        } else {
            await downloadPrivateKeyAsImage(StateManager.getUserEmail(), newPrivateKey)
        }
    }

    async function downloadPrivateKeyAsText(userEmail, privateKey) {
        let file = createFile([privateKey], "text/plain")
        downloadFile(file, `${userEmail}.key`)
    }

    async function downloadPrivateKeyAsImage(userEmail, privateKey) {
        let preparedEmailForImage = prepareUsernameForKeyImageText(userEmail, privateKey)
        let keyImage = await createImage(KEY_IMAGE_PATH)
        let preparedImage = await addTextOnImage(preparedEmailForImage, keyImage)
        let privateKeyZip = await createZip(privateKey, `privateKey.key`)
        let preparedKeyImageLink = createFile([preparedImage, privateKeyZip], "image/jpeg")
        downloadFile(preparedKeyImageLink, `${preparedEmailForImage}.jpeg`)
    }

    async function generateNewKeyPairAndReEncrypt() {
        try {
            const {publicKey, privateKey} = await generatePGPKeys(StateManager.getUserEmail(), newPassphrase)
            if (newLoginType === "emailPass") {
                let accessToken = generateSha512Hash(newPassphrase)
                await adjustLoginForUser({
                    mainChangeType,
                    newLoginType,
                    privateKey,
                    accessToken,
                    publicKey,
                    oldPrivateKey: StateManager.getPrivateKey(),
                    oldPassphrase: StateManager.getPassphrase()
                }, StateManager.getToken())
            } else {
                await downloadKey(StateManager.getUserEmail(), privateKey, keyDownloadOption)
                await adjustLoginForUser({
                    mainChangeType,
                    newLoginType,
                    publicKey,
                    oldPrivateKey: StateManager.getPrivateKey(),
                    oldPassphrase: StateManager.getPassphrase()
                }, StateManager.getToken())
            }
            StateManager.cleanState()
            toast.success("Your key has been changed. Please login again.")
            setTimeout(() => {
                reloadPage()
            })
        } catch (e) {

        }
    }

    function cancelReEncryption(){
        redirect("/mail")
    }

    return (
        <main>
            <div className={styles.container}>
                <div style={{width: "400px"}}>
                    <br></br>
                    <br></br>
                    {!reEncryptionOnGoing && (<>
                        <h2>Change Credentials</h2><br></br>
                        <StandardRadioGroup selected={mainChangeType} options={mainChangeTypes}
                                            onChange={(value) => setMainChangeType(value)}></StandardRadioGroup>
                        <br></br>
                        {mainChangeType === MAIN_CREDENTIALS_CHANGE_TYPE.changeKeyPair.value && (<>
                            <h4>Choose New Login Type</h4><br></br>
                            <p>Your existing emails, will be re-encrypted. It's a long process.</p><br></br>
                            <StandardRadioGroup selected={formOption} options={formOptions}
                                                onChange={(e) => setFormOption(e)}></StandardRadioGroup>

                            {formOption === REGISTER_FORM_RADIO_DATA.uploadPublicKey.value && (
                                <StandardFileInput width="100%" name="Public Key"
                                                   onChange={handlePublicKeyUpload}></StandardFileInput>)}

                            {(formOption === REGISTER_FORM_RADIO_DATA.generateKeys.value) && (<>
                                    <br></br>
                                    <label>Key Download Type</label>
                                    <br></br><br></br>
                                    <StandardRadioGroup selected={keyDownloadOption}
                                                        onChange={(e) => setKeyDownloadOption(e)}
                                                        options={keyDownloadOptions}></StandardRadioGroup>
                                    <br></br>
                                </>
                            )}

                            {(formOption === REGISTER_FORM_RADIO_DATA.generateKeys.value || formOption === REGISTER_FORM_RADIO_DATA.emailPass.value) && (
                                <StandardPasswordInput onChange={(e) => setNewPassphrase(e)} width="100%"
                                                       placeholder="Passphrase"></StandardPasswordInput>
                            )}
                        </>)}

                        {mainChangeType === MAIN_CREDENTIALS_CHANGE_TYPE.changePassphrase.value && (<>
                            <h4>Choose New Login Type</h4><br></br>
                            <p>Your existing private key will be re-encrypted. It's a quick process.</p><br></br>
                            <p>Please choose key download type after re-encryption, or use email pass login for ease of
                                access.</p>
                            <br></br>

                            <label><strong>New Login Type</strong></label><br></br><br></br>
                            <StandardRadioGroup selected={newLoginType} options={newLoginTypes}
                                                onChange={(value) => setNewLoginType(value)}></StandardRadioGroup><br></br>

                            {newLoginType === "uploadKey" && (<>
                                <label><strong>Key Download Type</strong></label><br></br><br></br>
                                <StandardRadioGroup selected={keyDownloadOption}
                                                    onChange={(e) => setKeyDownloadOption(e)}
                                                    options={keyDownloadOptions}></StandardRadioGroup><br></br>
                            </>)}

                            <StandardPasswordInput onChange={(e) => setNewPassphrase(e)} width="100%"
                                                   placeholder="New Passphrase"></StandardPasswordInput>
                        </>)}
                        <br></br>
                        <StandardButton innerText={"Submit"} onClick={handleSubmit}/>&nbsp;&nbsp;<StandardButton
                        innerText={"Cancel"} onClick={cancelReEncryption}/>
                    </>)}

                    {reEncryptionOnGoing && (<>
                            <label><strong>People</strong></label><br></br>
                            <p>{doneMessages} / {totalMessages} done</p>
                        </>
                    )}

                </div>
            </div>
            <ToastContainer containerId={TOAST_CONTAINER_ID}/>
        </main>
    );
}